<template>
    <div>
        <v-container fluid>
            <v-row class="p-3">
                <v-col
                        v-for="(image,index) in img"
                        :key="image.id"
                        cols="12"
                        class="mx-auto my-2 card boxStyle"
                        md="2"
                        :data-img="image.id"
                >
                    <v-radio-group class="p-0 m-0" v-model="selectedImage">
                        <v-radio
                                color="indigo"
                                :value="image.value"
                        ></v-radio>
                    </v-radio-group>
                    <img :src="image.full_path" class="img-fluid"
                         :key="image.id">
                    <p class="text-center my-0">{{ image.name }}</p>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
    name: "notePhone",
    data() {
        return {
            selectedImage: [],
            img: [
                {
                    id: '1',
                    name: 'دکمه ای',
                    value: 'button',
                    full_path: require('../../../../public/media/site/notebook/دکمه-ایی.png')
                },
                {
                    id: '2',
                    name: 'فنرزنی',
                    value: 'buffer',
                    full_path: require('../../../../public/media/site/notebook/فنریی2.png')
                },
                {
                    id: '3',
                    name: 'پرسی',
                    value: 'press',
                    full_path: require('../../../../public/media/site/notebook/پرسی.png')
                },
                {
                    id: '4',
                    name: 'کشی',
                    value: 'band',
                    full_path: require('../../../../public/media/site/notebook/دفترچه-تلفن-کشی.png')
                },
                {
                    id: '5',
                    name: 'چسبی',
                    value: 'sticky',
                    full_path: require('../../../../public/media/site/notebook/دفترچه-تلفن--چسبی.png')
                },
            ],
            count: 1,
        }
    },
    watch:{
        selectedImage() {
            this.$emit('persianName',this.img.find((x)=>x.value === this.selectedImage).name,"notePhone")
            this.$emit('input', this.selectedImage)
        }
    }
}
</script>

<style scoped>

</style>